import { createModel } from '@/store/tools';

const model = {
    namespace: 'dictionaries',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getDictionarieList': T('getDictionarieList'),
        },
        actions: {
            'getDictionarieList': A('getDictionarieList'),
        },
        sagas: {
            'getDictionarieList': S('getDictionarieList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyDisplayPositionService.listStrategyDisplayPosition'),
        },
        reducers: {
            'dictionarieList': R('getDictionarieList', []),
        }
    })
};
export default createModel(model);